function deface(s) {
    return s.replace(/Tiramis.(\s+Emstrangen)?/g, 'Cortona3D Solo Core');
}
module.exports = deface;